import React, { Component } from 'react';
import { Table, Input, Button } from 'reactstrap';
import moment from "moment";
import TooltipItem from '../../tools/TooltipItem';
import { connect } from 'react-redux';

class AthKeycardFitness extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableData: [],
            popData: [],
            formData: {
                pop: "0",
                startdate: moment().format("YYYY-MM-DD"),
                enddate: moment().add(1, 'd').format("YYYY-MM-DD"),
                monstart: "00:00:00",
                tuestart: "00:00:00",
                wedstart: "00:00:00",
                thustart: "00:00:00",
                fristart: "00:00:00",
                satstart: "00:00:00",
                sunstart: "00:00:00",
                monend: "23:59:59",
                tueend: "23:59:59",
                wedend: "23:59:59",
                thuend: "23:59:59",
                friend: "23:59:59",
                satend: "23:59:59",
                sunend: "23:59:59"
            },
            dataKey: 1,
            lockStatus: false
        }
        this.apiFetch("GetAthFitnessData", {}, "tableData")
        this.apiFetch("GetAthPopulationList", {}, "popData")
        this.apiFetch("AthKeycardGetLockStatus", {}, "lockStatus")
    }

    async apiFetch(url, body, stateItem) {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            ...body
        }
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.props.reduxData.apiKey },
            body: JSON.stringify(toSend)
        })
        const data = await response.json()
        this.setState({
            [stateItem]: data
        }, () => {
            if (stateItem == "tableData" && url != "GetAthFitnessData") {
                this.setState({
                    dataKey: this.state.dataKey + 1
                })
            }
        })
    }

    updateForm(field, val) {
        this.setState({
            formData: {...this.state.formData, [field]: val}
        })
    }

    //async changeValue(pk, target, value) {//This needs to have as one of its parameters the exact same name as the field, because this is being handled by dynamic SQL and it needs the exact name of what it should be updating
    //    //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //note: new methond doesn't need this function, but it's being left as a note about the target value being the same
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    let toSend = {
    //        userLevel: this.props.reduxData.userInfo.level.pk,
    //        pk: pk,
    //        target: target,
    //        value: value 
    //    }
    //    const response = await fetch('UpdateAthFitness', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    })
    //    const data = await response.json();
    //    //localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        tableData: data,
    //        dataKey: this.state.dataKey + 1
    //    })
    //}

    async lockButton() {
        let now = new Date()
        let printTime
        if (now.getMinutes() < 45) { //time is before :45
            if (now.getHours() + 1 > 24) {
                printTime = (now.getMonth() + 1) + "/"
                printTime = printTime + (now.getDay() + 1)
                printTime = printTime + " 00:05"
            }
            else {
                printTime = (now.getMonth() + 1) + "/" + now.getDay() + " " + (now.getHours() + 1) + ":05"
            }
        }
        else { // time is after :45
            if (now.getHours() + 2 > 24) {
                printTime = (now.getMonth() + 1) + "/" + now.getDay() + 2
                printTime = printTime + " 00:05"
            }
            else {
                printTime = (now.getMonth() + 1) + "/" + now.getDay() + " " + (now.getHours() + 2) + ":05"
            }
        }
        var printString = "The room is being "
        if (this.state.lockStatus) {
            printString = printString + "opened"
        }
        else {
            printString = printString + "closed"
        }
        printString = printString + ". The change will take effect at: " + printTime
        this.apiFetch("AthKeycardFlipLock", {}, "lockStatus")
        alert(printString)        
    }

    render() {//todo: should this be split into two functional components, one for the form and one for the data?
        return (//This first are is governing the form to add a new record. It looks almost exactly like the data areas.
            <div>
                <h2>Fitness</h2>
                <br />
                <div className="inlineCustom">The room is currently: {this.state.lockStatus ? <span style={{ color: "red" }}>CLOSED</span> : <span style={{ color: "red" }}>OPEN</span>}</div>
                <div className="rightAlignCustom"><Button onClick={() => this.lockButton()}>
                    {this.state.lockStatus ?<span>Open This Room</span>:<span>Lock This Room</span>}
                </Button></div>
                <Table striped>
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ "width": "33%" }}>
                                <Table borderless>
                                    <tbody>
                                        <tr><td><p/></td></tr>
                                        <tr>
                                            <td>
                                                <Input type="select" name="pop" id="pop" value={this.state.formData.pop} onChange={(e) => this.updateForm("pop",e.target.value)}>
                                                    <option value="0" disabled>Select Population</option>
                                                    {this.state.popData.map(item => (
                                                        <option value={item.pk}>{item.popname}</option>
                                                    ))}
                                                </Input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Start Date&emsp;&emsp;<Input type="date" name="startdate" id="startdate" value={this.state.formData.startdate} onChange={(e) => this.updateForm("startdate",e.target.value) } /></td>
                                        </tr>
                                        <tr>
                                            <td>End Date&emsp;&emsp;<Input type="date" name="enddate" id="enddate" value={this.state.formData.enddate} onChange={(e) => this.updateForm("enddate",e.target.value) } /></td>
                                        </tr>
                                        <tr>
                                            <td><Button color="success" onClick={() => this.apiFetch("AddAthFitnessPop", this.state.formData, "tableData")}>Add</Button></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </td>
                            <td style={{ "width": "33%" }}>
                                <Table borderless>
                                    <tbody>
                                        <tr>
                                            <td></td>
                                            <td>Start Time</td>
                                            <td>End Time</td>
                                        </tr>
                                        <tr>
                                            <td>Mondays</td>
                                            <td><Input type="time" name="mon_starttime" id="mon_starttime" value={this.state.formData.monstart} onChange={(e) => this.updateForm("monstart",e.target.value) } /></td>
                                            <td><Input type="time" name="mon_endtime" id="mon_endtime" value={this.state.formData.monend} onChange={(e) => this.updateForm("monend",e.target.value) } /></td>
                                        </tr>
                                        <tr>
                                            <td>Tuesdays</td>
                                            <td><Input type="time" name="tue_starttime" id="tue_starttime" value={this.state.formData.tuestart} onChange={(e) => this.updateForm("tuestart",e.target.value) } /></td>
                                            <td><Input type="time" name="tue_endtime" id="tue_endtime" value={this.state.formData.tueend} onChange={(e) => this.updateForm("tueend",e.target.value) } /></td>
                                        </tr>
                                        <tr>
                                            <td>Wednesdays</td>
                                            <td><Input type="time" name="wed_starttime" id="wed_starttime" value={this.state.formData.wedstart} onChange={(e) => this.updateForm("wedstart",e.target.value) } /></td>
                                            <td><Input type="time" name="wed_endtime" id="wed_endtime" value={this.state.formData.wedend} onChange={(e) => this.updateForm("wedend",e.target.value) } /></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </td>
                            <td style={{ "width": "33%" }}>
                                <Table borderless>
                                    <tbody>
                                        <tr>
                                            <td></td>
                                            <td>Start Time</td>
                                            <td>End Time</td>
                                        </tr>
                                        <tr>
                                            <td>Thursdays</td>
                                            <td><Input type="time" name="thu_starttime" id="thu_starttime" value={this.state.formData.thustart} onChange={(e) => this.updateForm("thustart",e.target.value) } /></td>
                                            <td><Input type="time" name="thu_endtime" id="thu_endtime" value={this.state.formData.thuend} onChange={(e) => this.updateForm("thuend",e.target.value) } /></td>
                                        </tr>
                                        <tr>
                                            <td>Fridays</td>
                                            <td><Input type="time" name="fri_starttime" id="fri_starttime" value={this.state.formData.fristart} onChange={(e) => this.updateForm("fristart",e.target.value) } /></td>
                                            <td><Input type="time" name="fri_endtime" id="fri_endtime" value={this.state.formData.friend} onChange={(e) => this.updateForm("friend",e.target.value) } /></td>
                                        </tr>
                                        <tr>
                                            <td>Saturdays</td>
                                            <td><Input type="time" name="sat_starttime" id="sat_starttime" value={this.state.formData.satstart} onChange={(e) => this.updateForm("satstart",e.target.value) } /></td>
                                            <td><Input type="time" name="sat_endtime" id="sat_endtime" value={this.state.formData.satend} onChange={(e) => this.updateForm("satend",e.target.value) } /></td>
                                        </tr>
                                        <tr>
                                            <td>Sundays</td>
                                            <td><Input type="time" name="sun_starttime" id="sun_starttime" value={this.state.formData.sunstart} onChange={(e) => this.updateForm("sunstart",e.target.value) } /></td>
                                            <td><Input type="time" name="sun_endtime" id="sun_endtime" value={this.state.formData.sunend} onChange={(e) => this.updateForm("sunend",e.target.value) } /></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </td>
                        </tr>
                        {this.state.tableData.length > 0 && this.state.tableData.map(item => (//Here wer'e actually displaying Real Data. We're also including a conditional for attempting to render when there's no data to render
                            <tr >
                                <td style={{ "width": "33%" }}>
                                    <Table borderless>
                                        <tbody>
                                            <tr><td><p /></td></tr>
                                            <tr>
                                                <td>
                                                    <TooltipItem id={item.pk} title={item.description.replaceAll("|", "\n")}>
                                                    <h3>{item.popname}</h3>
                                                    </TooltipItem>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Start Date&emsp;&emsp;<Input type="date" name="startdate" id="startdate" defaultValue={item.startdate} onBlur={(e) => {
                                                    /*if (e.target.value != item.startdate) { this.changeValue(item.pk, "StartDate", e.target.value) }*/
                                                    if (e.target.value != item.startdate) { this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "StartDate", value: e.target.value }, "tableData") }
                                                }} /></td>
                                            </tr>
                                            <tr>
                                                <td>End Date&emsp;&emsp;<Input type="date" name="enddate" id="enddate" defaultValue={item.enddate} onBlur={(e) => {
                                                    if (e.target.value != item.enddate) { this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "EndDate", value: e.target.value }, "tableData") }
                                                }} /></td>
                                            </tr>
                                            <tr>
                                                <td><Button color="danger" onClick={(e) => this.apiFetch("DeleteAthFitness", { targetpk: item.pk }, "tableData")}>Delete</Button></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </td>
                                <td style={{ "width": "33%" }}>
                                    <Table borderless>
                                        <tbody>
                                            <tr>
                                                <td></td>
                                                <td>Start Time</td>
                                                <td>End Time</td>
                                            </tr>
                                            <tr>
                                                <td>Mondays</td>
                                                <td><Input type="time" name="mon_starttime" id="mon_starttime" defaultValue={item.mon_starttime} onBlur={(e) => this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "Mon_StartTime", value: e.target.value }, "tableData")} /></td>
                                                <td><Input type="time" name="mon_endtime" id="mon_endtime" defaultValue={item.mon_endtime} onBlur={(e) => this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "Mon_EndTime", value: e.target.value }, "tableData")} /></td>
                                            </tr>
                                            <tr>
                                                <td>Tuesdays</td>
                                                <td><Input type="time" name="tue_starttime" id="tue_starttime" defaultValue={item.tue_starttime} onBlur={(e) => this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "Tue_StartTime", value: e.target.value }, "tableData")} /></td>
                                                <td><Input type="time" name="tue_endtime" id="tue_endtime" defaultValue={item.tue_endtime} onBlur={(e) => this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "Tue_EndTime", value: e.target.value }, "tableData")} /></td>
                                            </tr>
                                            <tr>
                                                <td>Wednesdays</td>
                                                <td><Input type="time" name="wed_starttime" id="wed_starttime" defaultValue={item.wed_starttime} onBlur={(e) => this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "Wed_StarTime", value: e.target.value }, "tableData")} /></td>
                                                <td><Input type="time" name="wed_endtime" id="wed_endtime" defaultValue={item.wed_endtime} onBlur={(e) => this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "Wed_EndTime", value: e.target.value }, "tableData")} /></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </td>
                                <td style={{ "width": "33%" }}>
                                    <Table borderless>
                                        <tbody>
                                            <tr>
                                                <td></td>
                                                <td>Start Time</td>
                                                <td>End Time</td>
                                            </tr>
                                            <tr>
                                                <td>Thursdays</td>
                                                <td><Input type="time" name="thu_starttime" id="thu_starttime" defaultValue={item.thu_starttime} onBlur={(e) => this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "Thu_StartTime", value: e.target.value }, "tableData")} /></td>
                                                <td><Input type="time" name="thu_endtime" id="thu_endtime" defaultValue={item.thu_endtime} onBlur={(e) => this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "Thu_EndTime", value: e.target.value }, "tableData")} /></td>
                                            </tr>
                                            <tr>
                                                <td>Fridays</td>
                                                <td><Input type="time" name="fri_starttime" id="fri_starttime" defaultValue={item.fri_starttime} onBlur={(e) => this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "Fri_StartTime", value: e.target.value }, "tableData")} /></td>
                                                <td><Input type="time" name="fri_endtime" id="fri_endtime" defaultValue={item.fri_endtime} onBlur={(e) => this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "Fri_EndTime", value: e.target.value }, "tableData")} /></td>
                                            </tr>
                                            <tr>
                                                <td>Saturdays</td>
                                                <td><Input type="time" name="sat_starttime" id="sat_starttime" defaultValue={item.sat_starttime} onBlur={(e) => this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "Sat_StartTime", value: e.target.value }, "tableData")} /></td>
                                                <td><Input type="time" name="sat_endtime" id="sat_endtime" defaultValue={item.sat_endtime} onBlur={(e) => this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "Sat_EndTIme", value: e.target.value }, "tableData")} /></td>
                                            </tr>
                                            <tr>
                                                <td>Sundays</td>
                                                <td><Input type="time" name="sun_starttime" id="sun_starttime" defaultValue={item.sun_starttime} onBlur={(e) => this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "Sun_StartTime", value: e.target.value }, "tableData")} /></td>
                                                <td><Input type="time" name="sun_endtime" id="sun_endtime" defaultValue={item.sun_endtime} onBlur={(e) => this.apiFetch("UpdateAthFitness", { pk: item.pk, target: "Sun_EndTime", value: e.target.value }, "tableData")} /></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </td>
                                </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(AthKeycardFitness);